// FloatingPostButton.js
import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import CreatePost from './CreatePost';
import AuthPrompt from './AuthPrompt';

const FloatingPostButton = ({ relays }) => {
  const [showModal, setShowModal] = useState(false);
  const [showAuthPrompt, setShowAuthPrompt] = useState(false);
  const { publicKey } = useAuth();

  const handleClick = () => {
	if (!publicKey) {
	  setShowAuthPrompt(true);
	} else {
	  setShowModal(true);
	}
  };

  return (
	<>
	  <button 
		className="floating-post-button"
		onClick={handleClick}
		aria-label="Create post"
	  >
		+
	  </button>

	  {showModal && (
		<div className="post-modal-overlay" onClick={() => setShowModal(false)}>
		  <div className="post-modal" onClick={e => e.stopPropagation()}>
			<button 
			  className="close-modal-button"
			  onClick={() => setShowModal(false)}
			>
			  ×
			</button>
			<h2>Create Post</h2>
			<CreatePost 
			  onPostCreated={() => setShowModal(false)}
			  enforceGovLink={true}
			  relays={relays}
			/>
		  </div>
		</div>
	  )}

	  {showAuthPrompt && (
		<AuthPrompt onClose={() => setShowAuthPrompt(false)} />
	  )}
	</>
  );
};

export default FloatingPostButton;